import { canViewAnalytics } from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

export const reportsSteps: TourStepConfig[] = [
  {
    id: "reports-tabs",
    target: "reports.tabs",
    title: "Report categories",
    content:
      "Four detailed breakdowns: how your users send, how your templates perform, what you've sent, and how recipients respond.",
    placement: "bottom",
    when: canViewAnalytics,
  },
  {
    id: "reports-content",
    target: "reports.content",
    title: "The selected report",
    content:
      "Totals, per-row detail and the date range it covers — the numbers behind the charts on Insights.",
    placement: "bottom",
    when: canViewAnalytics,
  },
];

export default reportsSteps;
